import { useEffect, useRef } from "react";

export const GoldParticles = ({ density = 60 }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let w = 0;
    let h = 0;
    let raf;
    const resize = () => {
      w = canvas.width = canvas.offsetWidth;
      h = canvas.height = canvas.offsetHeight;
    };
    resize();
    window.addEventListener("resize", resize);
    const particles = Array.from({ length: density }, () => ({
      x: Math.random(),
      y: Math.random(),
      r: Math.random() * 1.8 + 0.4,
      s: Math.random() * 0.00035 + 0.00008,
      o: Math.random() * Math.PI * 2,
      tw: Math.random() * 0.5 + 0.3,
    }));
    const tick = (t) => {
      ctx.clearRect(0, 0, w, h);
      for (const p of particles) {
        p.y -= p.s;
        if (p.y < -0.02) {
          p.y = 1.02;
          p.x = Math.random();
        }
        const x = (p.x + Math.sin(t * 0.0004 + p.o) * 0.012) * w;
        const a = 0.2 + Math.abs(Math.sin(t * 0.001 * p.tw + p.o)) * 0.5;
        ctx.beginPath();
        ctx.arc(x, p.y * h, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(212,175,55,${a})`;
        ctx.shadowColor = "rgba(212,175,55,0.8)";
        ctx.shadowBlur = 6;
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, [density]);

  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      data-testid="hero-particles"
      className="pointer-events-none absolute inset-0 h-full w-full"
    />
  );
};
